import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import I18n from 'I18n';
import VizExIconButton from 'visitor-ui-component-library/button/VizExIconButton';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import SVGSendOutline from 'visitor-ui-component-library-icons/icons/SVGSendOutline';
import { jsx as _jsx } from "react/jsx-runtime";
export function SendButton(_ref) {
  let props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(VizExIconButton, Object.assign({
    "aria-label": I18n.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.send'),
    "data-test-id": "chat-send-button",
    use: "default-on-background",
    shape: "circle"
  }, props, {
    children: /*#__PURE__*/_jsx(VizExIcon, {
      icon: /*#__PURE__*/_jsx(SVGSendOutline, {}),
      size: "18px"
    })
  }));
}
SendButton.displayName = 'SendButton';